import { Station } from '@mi-front/core';
import { Redirect } from 'react-router-dom';
import { useDefaultStation } from '../stations/hooks/useDefaultStation';

/**
 * Redirects to the default station (most recent or first) using the path
 * returned by the `to` function. Redirects to /no-stations when there are
 * no stations.
 */
export function DefaultStationRedirect({ to }: { to: (station: Station) => string }) {
  const defaultStation = useDefaultStation();

  if (!defaultStation) {
    return <Redirect to="/" />;
  }

  return <Redirect to={to(defaultStation)} />;
}
